import React from 'react'
import Section from '../Section'
import ExperienceUnit from '../ExperienceUnit'

import goodlifeLogo from '../../assets/images/experience/gl.png'
import tcLogo from '../../assets/images/experience/tc-logo.png'
import htLogo from '../../assets/images/experience/ht-logo.svg'
import rolloLogo from '../../assets/images/experience/elrollologo.png'
import cpLogo from '../../assets/images/experience/cp-logo.png'
import mcLogo from '../../assets/images/experience/mc-logo.png'
import wmLogo from '../../assets/images/experience/webmonster.png'
import mkLogo from '../../assets/images/experience/mk-logo.png'

class ExperienceSection extends React.Component {
  render() {
    return (
      <Section title="Experience">
        <div className="row">
        <ExperienceUnit
            logo={mkLogo}
            colour='#FFF'
            title='MarmonKeystone'
            link='https://www.marmonkeystone.com/'
            timeperiod='2017 - present'
            subtitle='I am helping modernize a legacy application they have been using from a while.'
          />
        <ExperienceUnit
            logo={goodlifeLogo}
            colour='#FF8926'
            title='GoodLifeUSA'
            link='https://www.goodlifeusa.com/'
            timeperiod='2017'
            subtitle='Laravel 5.3 & AWS, ACH payments, diverse third party 
            APIs consumption. Learned about MLM business.'
          />
          <ExperienceUnit
            logo={htLogo}
            colour='#202138'
            title='Hola Trabajo'
            link='https://www.holatrabajo.com/'
            timeperiod='2014 - 2017'
            subtitle='Used a MVC PHP framework, implemented a search engine, WebRTC, TDD and 
            all sorts of exciting stuff.'
          />
          <ExperienceUnit
            logo={rolloLogo}
            colour='#29abe3'
            title='El Rollo'
            link='https://www.elrollo.com.mx/'
            timeperiod='2014 - 2016'
            subtitle='I improved my experience in web security for this one. Also 
            consumed a lot of third party APIs for payments.'
          />
          <ExperienceUnit
            logo={tcLogo}
            colour='#FFF'
            title='TaquillaCero'
            link='https://www.taquillacero.com/'
            timeperiod='2014 - 2016'
            subtitle='I built several modules, such as
            user registration, participants number assignment and receiving payments through a third party.'
          />
          <ExperienceUnit
            logo={cpLogo}
            colour='#FFF'
            title='Cuponeate'
            link='https://www.cuponeate.mx/'
            timeperiod='2012 - 2016'
            subtitle='Cuponeate has been promoting companies 
            with customers via coupons, which are available for users from the website and the mobile app.'
          />
          <ExperienceUnit
            logo={mcLogo}
            colour='#403949'
            title='Maestro Creativo'
            link='https://www.maestrocreativo.com/'
            timeperiod='2010 - 2012'
            subtitle='Online Store. 
            This company helps teaches improve the quality of the lessons they teach using 
            diverse visual materials. I built this site from scratch, still kicking.'
          />
        </div>
      </Section>
    )
  }
}

export default ExperienceSection



// WEBPACK FOOTER //
// ./src/components/ExperienceSection/index.js